module.exports = __webpack_public_path__ + "img/返回顶部.fb2be787.svg";